import React from 'react';
import { alloy } from '../../colors';

// this component exists for the stepper
export interface HalfCircleProps {
  /** The class name of the svg, defaults to 'default'. */
  className?: string;
  /** The fill property of the path, defaults to ''. */
  color?: string;
  /** The fill property of the path, defaults to 'white'. */
  backgroundColor?: string;
  /** The width and height properties of the svg, defaults to '14'. */
  width?: number;
  /** The stroke property of the circle, defaults to alloy color. */
  outline?: string;
  /** The rotation direction, defaults to 'left'. */
  direction?: 'top' | 'left' | 'bottom' | 'right';
}

export const HalfCircle = ({
  className = 'default',
  color = '',
  backgroundColor = 'white',
  width = 14,
  outline = alloy,
  direction = 'left',
  ...rest
}: HalfCircleProps) => {
  const directions = {
    top: 90,
    left: 0,
    bottom: 270,
    right: 180,
  };
  return (
    <svg
      className={className}
      width={width}
      height={width}
      viewBox="0 0 24 24"
      transform={`rotate(${directions[direction]})`}
      {...rest}
    >
      <path fill={color} d="M11.9,0H12V24h-.1a12,12,0,0,1,0-24Z" transform="translate(0 0.02)" />
      <path fill={backgroundColor} d="M12.1,0H12V24h.1a12,12,0,0,0,0-24Z" transform="translate(0 0.02)" />
      <circle cx="12" cy="12" r="12" fill="none" stroke={outline} />
    </svg>
  );
};
